import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/navbar";
import { logoutThunk } from "../../redux/actions/auth-actions";
import { getUserThunk, setPage } from "../../redux/actions/user-actions";
import { useNavigate } from "/src/hooks/navigation";
// import theme
import theme from "../../theme";

// TODO: mejorar boolean 'isMobile'. mandar a reducer ergo, selector ( a ver quien se anima )
const shouldShowNavbar = (pathname = "") =>
  pathname.indexOf("/administrator") < 0 &&
  (pathname.indexOf("/chat") < 0 || window.innerWidth > theme.breakpoints.values.md) &&
  pathname.indexOf("/profile") < 0;

const Navbar = () => {
  const dispatch = useDispatch();
  const { navigate } = useNavigate();

  const isAdmin = useSelector((state) => state.user.data.isAdmin);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const showFaqs = useSelector((state) => state.misc.featureFlags["flag.exp.show_faq"]);
  const userId = typeof localStorage !== "undefined" && localStorage.getItem("user_id");

  useEffect(() => {
    if (userId) {
      dispatch(getUserThunk({ isAdmin }));
    }
  }, [userId]);

  const currentUser = useSelector((state) => state.user.data);
  const show = shouldShowNavbar("location.pathname");

  const handleLogout = () => {
    dispatch(logoutThunk(() => navigate("/")));
  };

  const handleSetLoginPage = (page) => {
    dispatch(setPage(page));
  };

  return (
    show && (
      <CustomNavbar
        user={currentUser}
        isAuthenticated={isAuthenticated}
        setLoginPage={handleSetLoginPage}
        logout={handleLogout}
        showFaqs={showFaqs}
      />
    )
  );
};

export default Navbar;
